import {
  articleDetailQueryKey,
  articleListQueryKey,
  mainTopArticleListQueryKey,
} from '@/lib/article-list';
import { useQuery } from '@tanstack/react-query';
import {
  getArticleDetail,
  getArticleList,
  getMainTopArticleList,
  getPrivacyArticleList,
} from '../article.service';
import { ApiResponse, QUERY_KEYS } from '../base-api';
import {
  ArticleEntity,
  ArticleListResponse,
  GetArticleListParams,
} from '../types/article.type';

interface QueryError {
  message?: string;
  code?: number;
  status?: number;
}

export const usePrivacyArticleList = () => {
  return useQuery<ApiResponse<ArticleEntity[]>>({
    queryKey: [QUERY_KEYS.ARTICLE, QUERY_KEYS.PRIVACY_POLICY],
    queryFn: getPrivacyArticleList,
  });
};

export const useArticleList = (params?: GetArticleListParams) => {
  return useQuery<ApiResponse<ArticleListResponse>>({
    queryKey: articleListQueryKey(params),
    queryFn: () => getArticleList(params),
  });
};

export const useArticleDetail = (id: number) => {
  return useQuery<ApiResponse<ArticleEntity>>({
    queryKey: articleDetailQueryKey(id),
    queryFn: () => getArticleDetail(id),
    enabled: !!id,
    retry: (failureCount, error) => {
      const queryError = error as QueryError;
      const isNotFoundError =
        queryError.status === 404 ||
        queryError.code === 404 ||
        queryError.message === '게시글을 찾을 수 없습니다.';

      if (isNotFoundError) {
        return false;
      }

      return failureCount < 3;
    },
  });
};

export const useMainTopArticleList = () => {
  return useQuery<ApiResponse<ArticleEntity[]>>({
    queryKey: mainTopArticleListQueryKey(),
    queryFn: () => getMainTopArticleList(),
  });
};
